module.exports = __webpack_public_path__ + "img/table-self-icon.b6f637f2.svg";